export const PropertyManagementAndDirectoryTemplate = [
	{
		children: [],
		id: '58933080-0686-4c5d-8b73-36aceabb8e50',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '0dd0c7c7-1385-4550-bf5c-77774133c98d',
		content: [
			{
				text: 'Purpose',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'bdee8574-4ed4-4007-b0c7-a83747fdc760',
		content: [
			{
				text: 'Organize all property and building information in one place for easy reference by facilities managers and staff.',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a8667beb-6a08-4efe-b2dd-5c3d0658a7d5',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '8cf3ab57-31b2-4871-b11e-d3d4ae8f7f07',
		content: [
			{
				text: '1. Property Overview',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'f20c4344-8aa2-47ea-89a4-67a354e6b29b',
		content: [
			{
				text: 'Property Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '0c8d471f-a32b-46de-88d1-3095d4733502',
		content: [
			{
				text: 'Address:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'd3eab31d-9525-4387-83df-6f6aa800fc67',
		content: [
			{
				text: 'Property Type: (Office, Retail, Industrial, Mixed-Use, etc.)',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'b2e2bb40-4bae-49a4-b4b2-253fd10b629f',
		content: [
			{
				text: 'Number of Floors / Units:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '0255e43a-03ff-449f-a8d9-94d83da0412e',
		content: [
			{
				text: 'Year Built / Last Renovation:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '0fddd79f-5c10-4cdb-a9a0-eac623a228ac',
		content: [
			{
				text: 'Site Manager / Facilities Manager:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '023531ea-cc57-4159-b83b-f36683e9c077',
		content: [
			{
				text: 'Contact Information: (Phone, Email)',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '58f45a2b-bbc1-480a-a198-ff9bd3c680c6',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'e9e731c5-d336-41a1-b571-b60d2cda9431',
		content: [
			{
				text: '2. Contacts',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '1fca1845-6ff1-442f-8179-3f1b280848aa',
		content: [
			{
				text: 'Property Management Company:',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '9d973fa4-adeb-49ff-8aec-207284264df2',
		content: [
			{
				text: 'Contact Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a03c7b0a-dc95-4e34-826a-021f9c47a629',
		content: [
			{
				text: 'Phone / Email:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '6b9c3a48-8a49-4d18-8d75-1b4239189e67',
		content: [
			{
				text: 'Security / Front Desk:',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a4dbb155-511c-46ca-ae38-040dbb0a34d6',
		content: [
			{
				text: 'Contact Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '74ad0e46-1df4-4a48-87be-ef61826f2633',
		content: [
			{
				text: 'Phone / Email:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '67cb6cbb-d031-4d65-9a9b-d3405ed66932',
		content: [
			{
				text: 'Maintenance / Engineering Team:',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '6f61a633-e17e-4bb3-b76b-2f7a010caec4',
		content: [
			{
				text: 'Contact Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'ab18c356-cf98-44e6-8286-e51abf1adbf5',
		content: [
			{
				text: 'Phone / Email:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'ce99fb2a-b934-498f-9e6e-132e5338ffaf',
		content: [
			{
				text: 'Cleaning / Janitorial Services:',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '28c7fdea-c47f-49d4-8c40-2a3894083735',
		content: [
			{
				text: 'Contact Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'c945c3cd-9701-417e-bbdb-f869377b1e8d',
		content: [
			{
				text: 'Phone / Email:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'b2274804-cb5a-4e4c-b8fc-7b45a83cf0e2',
		content: [
			{
				text: 'Other Vendors / Contractors:',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a4651814-3b79-410b-9770-16a2fae42f34',
		content: [
			{
				text: 'Contact Name:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '6d29763c-4f86-4cf3-865c-21d96c951d5e',
		content: [
			{
				text: 'Service:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'e4be1a20-2444-42e2-84e4-0ee63cd8afba',
		content: [
			{
				text: 'Contact Info:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '7bbd64a7-70af-494d-85ad-86788b9be4b2',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '3e39ff35-0fd7-4449-90a8-527009b1ef53',
		content: [
			{
				text: '3. Building Access & Security',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '23ac7feb-11ad-40f9-a6d0-4a905e6326bb',
		content: [
			{
				text: 'Main Entrances & Exits:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '00bc74db-a61d-4d5b-84b5-99e571a76833',
		content: [
			{
				text: 'Access Control Systems: (Keycards, Biometric, Codes, etc.)',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'b3ffe591-60e7-4705-bdd6-f72f51a1076a',
		content: [
			{
				text: 'Visitor Management Procedure:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'ec149e44-2ea3-430b-955d-d1bb1459535f',
		content: [
			{
				text: 'Emergency Exits & Evacuation Routes:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'af018ee4-3247-42c3-97bd-d4c660e36e4c',
		content: [
			{
				text: 'After-Hours Contact / Security Number:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'ebf0810c-f3ed-4314-9d9d-c4edc5b43c16',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'acb0c157-c21c-4f56-ad34-8c11e65c14be',
		content: [
			{
				text: '4. Utilities & Infrastructure',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'b2939556-c171-4943-bb6e-99fe9dba33ef',
		content: [
			{
				text: 'HVAC Systems / Location:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '3c9dc13f-0126-4a3d-ac07-efe90c2c1265',
		content: [
			{
				text: 'Electrical Panels / Locations:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '651ce2ae-2a78-4da4-bd0d-370fcee20b52',
		content: [
			{
				text: 'Water Shut-off Points:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '58a5764b-8e10-4ca2-a608-de93e17e383e',
		content: [
			{
				text: 'Gas Shut-off Points:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a210f46d-151e-4211-a59f-04a85ad7e080',
		content: [
			{
				text: 'Elevators / Escalators:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '2ee43858-695b-4a4a-83ae-f34bc8745dfe',
		content: [
			{
				text: 'Fire Safety Systems: (Alarms, Sprinklers, Extinguishers)',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'aaf9bb67-07e3-4cc3-81c6-f9f64f884120',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '20b56cbd-8410-4a83-9e0b-fe7f6f9ad7cd',
		content: [
			{
				text: '5. Important Documents / Files',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'ef0693f1-cf90-4e3a-b39c-98ed0d304fbe',
		content: [
			{
				text: 'Lease Agreements:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'c133155a-40df-41c3-b50c-9a4023475233',
		content: [
			{
				text: 'Insurance Certificates:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'c63d435a-954a-4f99-a0f4-103f512289cd',
		content: [
			{
				text: 'Service Contracts / Warranties:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '61a64280-5693-4875-a0a8-590c2b056b4e',
		content: [
			{
				text: 'Compliance Certificates / Safety Inspections:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'e1e17e10-69d5-482c-b42d-8627a537b520',
		content: [
			{
				text: 'Blueprints / Floor Plans:',
				type: 'text',
				styles: {},
			},
		],
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'da3c36cd-5881-4bf9-b2cf-04d923c2e72d',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: '22f3b11d-9bcf-41ed-8666-10a4f945d227',
		content: [
			{
				text: '6. Notes / Additional Information',
				type: 'text',
				styles: {
					bold: true,
				},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'a550bb36-91bd-4825-97ba-202064beebae',
		content: [
			{
				text: 'Please include other relevant details, reminders, or site-specific information here.',
				type: 'text',
				styles: {},
			},
		],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
	{
		children: [],
		id: 'fd16b719-4618-4fe0-93b5-c62c7d37b8bf',
		content: [],
		type: 'paragraph',
		props: {
			textColor: 'default',
			textAlignment: 'left',
			backgroundColor: 'default',
		},
	},
];
